import { Moment } from 'moment';
import { StudyProgram } from './study-program';

export class Promotion {

    constructor(
        public start: Moment,
        public end: Moment,
        public description: string,
        public studyProgram: StudyProgram,
        public id?: number
    ){}
}
